import { bool, func } from 'prop-types';
import React from 'react';

import CurrencyFormat from '../../generic/CurrencyFormat';
import ShareInput from '../../generic/ShareInput';
import { agreementShape } from '../../prop-types';
import DerivedCurrencyInput from '../../quote-editor/utils/DerivedCurrencyInput';

const splits = [
  { title: 'Media Managed', name: 'mediaManagedBudgetShare' },
  { title: 'Media Self Service', name: 'mediaSelfServiceBudgetShare' },
  { title: 'Creative', name: 'creativeBudgetShare' },
  { title: 'Consumer Insights', name: 'ciBudgetShare' },
  { title: 'Other', name: 'otherBudgetShare' },
];

function AgreementBusinessSplit({ model, onChange, readOnly }) {
  const inputProps = { onChange, readOnly };
  const shareSum = splits.reduce((sum, { name }) => sum + model[name], 0);
  return (
    <table className="table">
      <thead>
        <tr>
          <th>Expected Revenues</th>
          <th>%</th>
          <th>EUR</th>
        </tr>
      </thead>
      <tbody>
        {splits.map(({ name, title }) => (
          <tr key={name}>
            <td>{title}</td>
            <td>
              <ShareInput value={model[name]} name={name} {...inputProps} />
            </td>
            <td>
              <DerivedCurrencyInput
                id={`agr-${name}`}
                name={name}
                share={model[name]}
                budget={model.budget}
                {...inputProps}
              />
            </td>
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr>
          <td />
          <td>
            <ShareInput
              className="text-nowrap"
              displayType="text"
              value={shareSum}
            />
          </td>
          <td>
            <CurrencyFormat
              className="text-nowrap"
              name="budget"
              value={model.budget}
              text
            />
          </td>
        </tr>
      </tfoot>
    </table>
  );
}

AgreementBusinessSplit.propTypes = {
  model: agreementShape.isRequired,
  readOnly: bool.isRequired,
  onChange: func,
};

AgreementBusinessSplit.defaultProps = {
  onChange: undefined,
};

export default AgreementBusinessSplit;
